import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("order", ["restaurantDetails"])
  },
  methods: {
    navigateToWhatsappChat() {
      window.open(
        `https://wa.me/${
          this.restaurantDetails?.whatsapp_platform?.number || ""
        }`
      );
    }
  }
};
